var render = function (_h,_vm) {var _c=_vm._c;return _c('v-row',_vm._l((6),function(item){return _c('v-col',{key:item,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('v-skeleton-loader',{attrs:{"type":"card"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }